<template>
  <div id="monthly-wrapper">
    <vue-monthly-picker
      :value="value"
      :monthLabels="monthLabels"
      :max="maxMonthToBeSelected"
      :dateFormat="MONTHLY_PICKER_FORMAT"
      :clear-option="false"

      @selected="date => $emit('input', date)"
    />
  </div>
</template>

<script>
import moment from "moment";
import VueMonthlyPicker from "vue-monthly-picker";

export default {
  components: {
    VueMonthlyPicker,
  },

  props: {
    value: {
      required: true,
    },
  },

  data: () => ({
    MONTHLY_PICKER_FORMAT: 'MMM YYYY',
    maxMonthToBeSelected: moment(),
  }),

  computed: {
    monthLabels() {
      return this.$store.state.utils.monthsShort;
    },
  },
}
</script>

<style>
#monthly-wrapper .vue-monthly-picker .input {
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/VectorWidgets/ux/MonthPicker.vue